import React from "react";

/**
 * Fondos de sección: estudio vacío, luz y ciclorama.
 *
 * QUÉ SON Y QUÉ NO SON. Son escenarios y luz. No hay sujeto en ninguno: ni
 * plato, ni persona, ni producto, ni propiedad. No son trabajo fotográfico de
 * Omega y en ninguna parte se presentan como tal — el portafolio solo se llena
 * con fotos propias (ver data/portafolio.js) y la galería vacía dice
 * explícitamente que falta. Estas imágenes ocupan el lugar que ocuparía un
 * color plano.
 *
 * POR QUÉ EXISTEN. Una sección negra lisa en la web de un fotógrafo se lee como
 * una web sin fotos. Mientras el portafolio real esté vacío, la alternativa no
 * era una foto: era un rectángulo.
 *
 * DOS FAMILIAS, DOS VELOS. Los fondos oscuros llevan velo de carbón para
 * sostener el contraste del texto blanco; el ciclorama blanco lleva velo de
 * papel, porque encima va texto oscuro. El velo no es maquillaje: sin él, la
 * zona iluminada de la imagen no pasa AA.
 *
 * APILADO. Se pinta en flujo normal dentro de un contenedor `relative`, sin
 * z-index negativo — un `-z-10` quedaría detrás del fondo opaco de la propia
 * sección y no se vería. El contenido de la sección va en `relative z-10`.
 */

const FONDOS = {
  /** Haz diagonal desde arriba a la izquierda. */
  centro: { base: "/fotografia/hero/estudio-luz", claro: false },
  /** Luz rasante desde la derecha. Cierres y CTA. */
  lateral: { base: "/fotografia/hero/estudio-luz-lateral", claro: false },
  /**
   * Softbox encendido a la derecha del cuadro, ciclorama vacío.
   * Para el hero: el titular cae sobre el lado oscuro y la luz queda libre.
   */
  softbox: { base: "/fotografia/hero/estudio-softbox", claro: false, lateral: true },
  /** Luz recortada por rejilla sobre pared vacía. Divisores. */
  rejilla: { base: "/fotografia/hero/estudio-rejilla", claro: false },
  /** Ciclorama blanco sin costura: el fondo real del trabajo de producto. */
  cicloBlanco: { base: "/fotografia/hero/ciclo-blanco", claro: true },
};

const FondoEstudio = ({ variante = "centro", priority = false, className = "" }) => {
  const fondo = FONDOS[variante] || FONDOS.centro;

  /*
    En el hero el velo es un degradado horizontal: opaco donde va el texto y
    casi transparente sobre el softbox. Un velo plano lo bastante fuerte para
    el titular apagaría justo la luz que hace que la sección se vea como un
    estudio.
  */
  const velo = fondo.claro
    ? "bg-sand-50/70"
    : fondo.lateral
    ? "bg-gradient-to-r from-navy-950/90 via-navy-950/70 to-navy-950/25"
    : "bg-navy-950/60";

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
    >
      <img
        src={`${fondo.base}-1344.webp`}
        srcSet={`${fondo.base}-800.webp 800w, ${fondo.base}-1344.webp 1344w`}
        sizes="100vw"
        alt=""
        width={1344}
        height={752}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchpriority={priority ? "high" : undefined}
        className="h-full w-full object-cover opacity-90"
      />
      <div className={`absolute inset-0 ${velo}`} />
    </div>
  );
};

export default FondoEstudio;
